import { slugify } from './slugify.cjs';

export const extractTelOrMailFromLink = (link) =>
  link?.replace(/(^mailto|^tel)\:\/?\/?/, '');

export const isMailLink = (link) => /^mailto\:/.test(link);
export const isTelLink = (link) => /^tel\:/.test(link);
export const buildMailLink = (email) => `mailto:${email}`;
export const buildTelLink = (tel) => `tel:${tel}`;
export const withProtocol = (link) => {
  if (!link) {
    return link;
  }

  const parts = link.split('//');

  if (parts.length === 1) {
    return `https://${link}`;
  }

  return [parts[0] || 'https:', parts[1]].join('//');
};

export const normalizeInternalLink = (link) => {
  let normalized = link;

  if (normalized && !normalized.startsWith('/')) {
    normalized = `/${normalized}`;
  }

  normalized = slugify(normalized, true);

  return normalized;
};
